import Swal from 'sweetalert2'
import {authenticationStore} from '@/main'

import {createHttp} from '@shared/http/createAxios'
import {attachAuthHeader, attach401Redirect, attach403Alert} from '@shared/http/helpers'
import {attach401Refresh} from '@shared/http/refreshInterceptor'
import {redirectToExternalUrl} from '@shared-utils/url/redirectToExternalUrl'
import {removeUrlParams} from '@shared-utils/url/removeUrlParams'
import {AppUrls} from '@shared-utils/auth/appUrls'
import {getImpersonationUserToken, clearImpersonationUserToken} from '@shared-utils/auth/impersonation/helpers'
import {REFRESH_TOKEN_KEY} from '@shared/constants/auth'

const axios = createHttp({
  baseURL: process.env.VUE_APP_API_URL || 'http://127.0.0.1:8000',
})

attachAuthHeader(axios, () => authenticationStore.getAuthToken())

attach401Refresh(axios, {
  refresh: () => authenticationStore.refreshAccessToken(),
  onRefreshFail: () => authenticationStore.removeUserToken(),
  shouldRefresh: () => !getImpersonationUserToken() && !!localStorage.getItem(REFRESH_TOKEN_KEY),
})

attach401Redirect(axios, {
  redirectToLogin: async () => {
    if (getImpersonationUserToken()) {
      clearImpersonationUserToken()
    } else {
      await authenticationStore.removeUserToken()
    }

    redirectToExternalUrl(AppUrls.login(), {
      redirect_url: removeUrlParams(window.location.href, ['code', 'redirect_url', 'redirect_uri']),
    })
  },
})

attach403Alert(axios, msg => Swal.fire({title: msg, icon: 'error'}))

export default axios
